import { render } from "./EvaluacionMain.vue?vue&type=template&id=975a82dc&scoped=true"
import script from "./EvaluacionMain.vue?vue&type=script&lang=js"
export * from "./EvaluacionMain.vue?vue&type=script&lang=js"

import "./EvaluacionMain.vue?vue&type=style&index=0&id=975a82dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-975a82dc"]])

export default __exports__